import type React from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload } from 'lucide-react';
import { Button } from 'shared-portal-components-v2';

import { classNames } from '@/utils/classNames.utils';

interface FileUploadDropZoneProps {
  onFilesAdded: (files: File[]) => void;
  isDisabled?: boolean;
  maxSize?: number;
  accept?: Record<string, string[]>;
}

export default function FileUploadDropZone({
  onFilesAdded,
  isDisabled = false,
  maxSize,
  accept,
}: FileUploadDropZoneProps): React.JSX.Element {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onFilesAdded,
    maxSize,
    accept,
    disabled: isDisabled,
  });

  return (
    <div
      {...getRootProps()}
      className={classNames(
        'rounded-lg border-2 border-dashed p-8 text-center transition-colors',
        isDragActive
          ? 'border-primary bg-primary/5'
          : 'border-border hover:border-primary/50 hover:bg-accent/5',
        isDisabled && 'pointer-events-none opacity-50',
      )}
    >
      <input {...getInputProps()} />
      <Upload className="mx-auto mb-4 h-12 w-12 text-muted-foreground" />
      <h3 className="mb-2 font-medium">
        {isDragActive ? 'Drop files here' : 'Drop files here or click to browse'}
      </h3>
      <Button variant="outline" size="md" className="pointer-events-none cursor-pointer">
        Choose Files
      </Button>
    </div>
  );
}
